import React from 'react'
import Headerbar  from "./components/common/Headerbar";
import Titlebar  from "./components/common/Titlebar";
import LoginComponent from './components/user/login'

const Login = ({deferredPrompt}) => {
  return (
    <><Headerbar /><Titlebar name="Hindustan Gold" /><LoginComponent deferredPrompt={deferredPrompt} /></>
  )
}

export default Login